import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  ECONOMY = 'Economy',
  CAPITAL_ACCOUNT = 'Capital Account',
  STREETWISE = 'Streetwise',
  HEARD_STREET = 'Heard on the Street',
  MONETARY_POLICY = '金融政策ウオッチ'
}

const { WORLD_ECONOMY, MONETARY_POLICY, STREET_WISE, THE_OUTLOOK, CAPITAL_ACCOUNT, HEARD } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [WORLD_ECONOMY, MONETARY_POLICY, THE_OUTLOOK, CAPITAL_ACCOUNT] } }
    ]
  },
  ...DEFAULT_SORT
};

const CAPITAL_ACCOUNT_QUERY = createSupportingModule([CAPITAL_ACCOUNT]);

const STREETWISE_QUERY = createSupportingModule([STREET_WISE]);

const HEARD_QUERY = createSupportingModule([HEARD]);

const MONETARY_POLICY_QUERY = createSupportingModule([MONETARY_POLICY]);

export { baseQuery as MAIN, SECTION_ENUM, CAPITAL_ACCOUNT_QUERY, STREETWISE_QUERY, HEARD_QUERY, MONETARY_POLICY_QUERY };
